module.exports = __webpack_public_path__ + "static/img/104903.189875a2.png";